// extracted by mini-css-extract-plugin
module.exports = {"chipUfs":"styles_chipUfs__3PH49","chipText":"styles_chipText__2B5bC"};